import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Slider from "react-slick";

// Images
import PartnerLogo1 from '../../../images/partner/apex-logo-dark.svg';
import PartnerLogo2 from '../../../images/partner/logo-2.png';
import PartnerLogo3 from '../../../images/partner/logo-3.jpeg';
import PartnerLogo4 from '../../../images/partner/logo4.png';
import PartnerLogo5 from '../../../images/partner/logo5.png';
import PartnerLogo6 from '../../../images/partner/logo6.png';

class ClientLogo1 extends Component{
	
	render(){
		
		const settings = {
			dots: true,
			infinite: true,
			speed: 500,
			slidesToShow: 6,
			slidesToScroll: 1,
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 3,
					}
				},
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 5,
					}
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 4,
					}
				},
				{
					breakpoint: 360,
					settings: {
						slidesToShow: 3,
					}
				}
			]
		};
		
		return(
			<>
				<Slider {...settings} className="dots-style-1 arrow-none">
					<div className="item">
						<div className="client-logo" >
							<a href="https://apexservice.com/"><img src={PartnerLogo1} alt=""/></a>
						</div>
					</div>
					
					<div className="item">
						<div className="client-logo">
							<a href="https://www.linkedin.com/company/unicoh-specialty-chemicals/"><img src={PartnerLogo3} alt=""/></a>
						</div>
					</div>
					<div className="item">
						<div className="client-logo">
							<a href="https://uisinternational.com/"><img src={PartnerLogo2} alt=""/></a>
						</div>
					</div>
					<div className="item">
						<div className="client-logo" >
							<a href="https://apexservice.com/"><img src={PartnerLogo1} alt=""/></a>
						</div>
					</div>
					
					<div className="item">
						<div className="client-logo">
							<a href="https://www.linkedin.com/company/unicoh-specialty-chemicals/"><img src={PartnerLogo3} alt=""/></a>
						</div>
					</div>
					<div className="item">
						<div className="client-logo">
							<a href="https://uisinternational.com/"><img src={PartnerLogo2} alt=""/></a>
						</div>
					</div>
				</Slider >
			</>
		);
	}
}

export default ClientLogo1;